exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#waitingForServer[data-v-716e542e] {\n  position: fixed;\n  color: white;\n  z-index: 500;\n  right: 10px;\n  top: 15px;\n}\n#waitingForServer i[data-v-716e542e] {\n    text-shadow: 0 0 2px #00695C;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-716e542e","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/WaitingForServer.vue
// module id = 660
// module chunks = 3